module.exports = __webpack_public_path__ + "static/media/90-dias.4f79d363.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/90-dias.svg
// module id = 166
// module chunks = 0